import {
  Bug,
  Wind,
  Rat,
  HeartPulse,
  Droplets,
  Home,
  Leaf,
  Timer,
  Recycle,
  Sparkles,
} from "lucide-react";

export const reasons = [
  {
    id: 1,
    icon: Rat,
    title: "Deter Pests & Vermin",
    description:
      "Dirty bins attract rats, mice, flies, maggots, and mosquitoes to your property. Regular cleaning removes organic residue that draws these unwanted visitors to your doorstep.",
  },
  {
    id: 2,
    icon: Wind,
    title: "Eliminate Foul Odours",
    description:
      "Rotting food waste and residue create persistent, stomach-turning smells that linger long after collection day. Hospital grade cleaning neutralises odours at the source, leaving your bin smelling fresh.",
  },
  {
    id: 3,
    icon: Bug,
    title: "Kill Harmful Bacteria",
    description:
      "Your wheelie bin is a breeding ground for dangerous bacteria including E.coli, Salmonella, and Listeria. (ESPECIALLY IF THE BIN LINER BECOMES TORN!) Our hospital grade cleaning eliminates 99.9% of these harmful pathogens.",
  },
  {
    id: 4,
    icon: HeartPulse,
    title: "Protect Your Family's Health",
    description:
      "Airborne bacteria from dirty bins can cause respiratory issues, skin infections, and gastrointestinal illness. Keep your family safe with regular professional cleaning.",
  },
  {
    id: 5,
    icon: Droplets,
    title: "Prevent Mould & Fungus",
    description:
      "Moisture trapped in your bin creates the perfect environment for mould and fungal growth. Our hospital grade treatment eliminates spores and prevents regrowth.",
  },
  {
    id: 6,
    icon: Home,
    title: "Boost Your Kerb Appeal",
    description:
      "Stained, grimy bins dragged to the kerbside reflect poorly on your property. Clean bins show pride in your home and maintain neighbourhood standards.",
  },
  {
    id: 7,
    icon: Leaf,
    title: "Eco-Friendly Cleaning",
    description:
      "Dirty bin runoff contaminates drains and local waterways. Our eco-friendly hospital grade process uses no harsh chemicals, protecting the environment while keeping your bin spotless.",
  },
  {
    id: 8,
    icon: Timer,
    title: "Extend Your Bin's Lifespan",
    description:
      "Built-up grime, acids from decomposing waste, and corrosion damage your bin over time. Regular cleaning prevents degradation and saves you replacement costs.",
  },
  {
    id: 9,
    icon: Recycle,
    title: "Keep Recycling Clean",
    description:
      "Contaminated recycling bins can cause entire loads to be rejected at sorting facilities. Clean bins ensure your recyclables actually get recycled.",
  },
  {
    id: 10,
    icon: Sparkles,
    title: "Total Peace of Mind",
    description:
      "With Steamers' regular clean, your bins are always fresh, sanitised and ready to go ...because you might have 99 problems, but a stinky bin doesn't have to be one!",
  },
];

export const howItWorks = [
  {
    step: 1,
    title: "Sign Up",
    description:
      "Choose to pay monthly or annually and we'll visit every 2 weeks on your scheduled day. No contracts - cancel anytime.",
  },
  {
    step: 2,
    title: "We Clean",
    description:
      "You don't need to be home, just make sure your bins are accessible (so we don't need to trouble you) and our team will take care of the rest! We'll remove the liner bag and re-insert after we're done, even if it isn't empty.",
  },
  {
    step: 3,
    title: "Enjoy Fresh Bins",
    description:
      "Your bins are returned neatly sparkling clean, sanitised, and deodorised. It's that simple.",
  },
];

export const navLinks = [
  { label: "Why Clean?", href: "#reasons" },
  { label: "How It Works", href: "#how-it-works" },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wheelie-bin-care/artifacts/8nqt9jx6_Steamers%20Logo%20%28on%20white%29.png";

export const LOGO_TRANSPARENT =
  "https://customer-assets.emergentagent.com/job_3d163003-53b2-4a24-b636-2fbdde0d9a2c/artifacts/w1lpcwp5_Steamers%20Logo%20%28transparent%29.png";

export const APPLE_PAY_MARK =
  "https://customer-assets.emergentagent.com/job_3d163003-53b2-4a24-b636-2fbdde0d9a2c/artifacts/e6bwhgqq_Apple_Pay_Mark_RGB_041619.svg";

export const GOOGLE_PAY_MARK =
  "https://customer-assets.emergentagent.com/job_3d163003-53b2-4a24-b636-2fbdde0d9a2c/artifacts/lg90krz5_google-pay-mark_800.svg";
